import messageSound from "../assets/sounds/message.wav";

class NotificationSound {
  constructor() {
    this.enabled = true;
    this.volume = 0.5;
    this._messageAudio = null;
  }

  _getMessageAudio() {
    if (!this._messageAudio) {
      this._messageAudio = new Audio(messageSound);
    }
    return this._messageAudio;
  }

  play(type = "message") {
    if (!this.enabled) return;

    if (type === "message") {
      const audio = this._getMessageAudio();
      audio.volume = this.volume;
      audio.currentTime = 0;
      audio.play().catch(() => {});
      return;
    }

    // Fallback synthesiser for other types (mention, success, error)
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    const ctx = new AudioContext();
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();
    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);
    const t = ctx.currentTime;

    switch (type) {
      case "mention":
        oscillator.frequency.setValueAtTime(1200, t);
        gainNode.gain.setValueAtTime(this.volume * 0.4, t);
        gainNode.gain.exponentialRampToValueAtTime(0.01, t + 0.3);
        oscillator.start(t);
        oscillator.stop(t + 0.3);
        break;
      case "success":
        oscillator.frequency.setValueAtTime(600, t);
        oscillator.frequency.setValueAtTime(800, t + 0.1);
        gainNode.gain.setValueAtTime(this.volume * 0.3, t);
        gainNode.gain.exponentialRampToValueAtTime(0.01, t + 0.25);
        oscillator.start(t);
        oscillator.stop(t + 0.25);
        break;
      case "error":
        oscillator.frequency.setValueAtTime(400, t);
        oscillator.frequency.setValueAtTime(300, t + 0.1);
        gainNode.gain.setValueAtTime(this.volume * 0.3, t);
        gainNode.gain.exponentialRampToValueAtTime(0.01, t + 0.3);
        oscillator.start(t);
        oscillator.stop(t + 0.3);
        break;
      default:
        oscillator.frequency.setValueAtTime(800, t);
        gainNode.gain.setValueAtTime(this.volume * 0.3, t);
        gainNode.gain.exponentialRampToValueAtTime(0.01, t + 0.15);
        oscillator.start(t);
        oscillator.stop(t + 0.15);
    }
  }

  enable() {
    this.enabled = true;
    localStorage.setItem("notificationSoundEnabled", "true");
  }

  disable() {
    this.enabled = false;
    localStorage.setItem("notificationSoundEnabled", "false");
  }

  toggle() {
    this.enabled ? this.disable() : this.enable();
    return this.enabled;
  }

  isEnabled() {
    return this.enabled;
  }

  setVolume(vol) {
    this.volume = Math.max(0, Math.min(1, vol));
    localStorage.setItem("notificationSoundVolume", this.volume.toString());
  }

  getVolume() {
    return this.volume;
  }

  loadPreferences() {
    const enabled = localStorage.getItem("notificationSoundEnabled");
    if (enabled !== null) this.enabled = enabled === "true";

    const volume = localStorage.getItem("notificationSoundVolume");
    if (volume !== null) this.volume = parseFloat(volume);
  }
}

const notificationSound = new NotificationSound();
notificationSound.loadPreferences();

export default notificationSound;
